import React from 'react';
import styles from './SocialButtonsList.scss';
import { IconButton } from '../IconButton/IconButton';
import classNames from 'classnames';
import { facebookIcon } from '@justgiving/icons';
import Svg from '@justgiving/svg';
import { captureException } from '@sentry/browser';

interface FacebookShareRoundProps {
  className?: string;
  url: string;
}

export const FacebookShareRound: React.FunctionComponent<FacebookShareRoundProps> = ({
  className,
  url,
}) => {
  const handleClick = () => {
    FB.ui(
      {
        method: 'share',
        href: url,
      },
      response => {
        if (response && (response.error_message || response.error_code)) {
          captureException({
            facebookErrorCode: response.error_code,
            facebookErrorMessage: response.error_message,
          });
        }
      },
    );
  };

  return (
    <IconButton
      className={`${styles.roundButton} ${className}`}
      onClick={handleClick}
    >
      <div className={classNames(styles.iconWrapper, styles.facebook)}>
        <Svg markup={facebookIcon} className={styles.icon} />
      </div>
      Facebook
    </IconButton>
  );
};
